const authenticate = ({ login }) => ({ dispatch }) => next => action => {
  if (action && (action.status === 401 || action.status === 403)) {
    dispatch(login());
  }

  return next(action);
};

export { authenticate, authenticate as default };
